import { render, staticRenderFns } from "./emailNotificationSettings.vue?vue&type=template&id=85ea5ad0&scoped=true"
import script from "./emailNotificationSettings.vue?vue&type=script&lang=js"
export * from "./emailNotificationSettings.vue?vue&type=script&lang=js"
import style0 from "./emailNotificationSettings.vue?vue&type=style&index=0&id=85ea5ad0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85ea5ad0",
  null
  
)

export default component.exports